import { render, staticRenderFns } from "./L2tpStaticIpWizard.vue?vue&type=template&id=86527f7a&"
import script from "./L2tpStaticIpWizard.vue?vue&type=script&lang=js&"
export * from "./L2tpStaticIpWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports